"use client";

import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reviews = [{
  id: 1,
  rating: 5,
  quote: "B&B Veterans did an amazing job remodeling our kitchen. Highly recommended!",
  author: "John D.",
  position: "Homeowner"
}, {
  id: 2,
  rating: 5,
  quote: "Professional, timely, and affordable. Will use again for other projects.",
  author: "Sarah P.",
  position: "Client"
}, {
  id: 3,
  rating: 5,
  quote: "Outstanding quality and attention to detail. The team exceeded our expectations.",
  author: "Michael R.",
  position: "Homeowner"
}];
export default function CustomerReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="customer-reviews" ref={ref} className="bg-dark-background py-24 px-4">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-16 text-center text-4xl font-bold text-white/90">
          Customer Reviews
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((review, i) => <Card key={review.id} data-index={i} className={`
                bg-white/10 border-white/20 text-white
                hover:-translate-y-0.5 hover:shadow-strong
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                ${isVisible ? "animate-fade-in-up" : "opacity-0"}
              `} style={{
          animationDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <CardContent className="flex flex-col gap-4">
                <div className="flex gap-1">
                  {Array.from({
                length: review.rating
              }).map((_, starIndex) => <Star key={starIndex} className="h-5 w-5 fill-primary text-primary" />)}
                </div>

                <p className="italic text-white/90 leading-relaxed">
                  "{review.quote}"
                </p>

                <div className="mt-2">
                  <p className="font-bold text-white">{review.author}</p>
                  <p className="text-sm text-white/70">{review.position}</p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}